import React from "react";

function Feedback() {
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Feedback
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry dt</th>
                        <th style={{ textAlign: "center" }}>Entry time</th>
                        <th style={{ textAlign: "center" }}>LID</th>
                        <th style={{ textAlign: "center" }}>Points given</th>
                        <th style={{ textAlign: "center" }}>Remark</th>
                        <th style={{ textAlign: "center" }}>
                          Reply to remark Entry
                        </th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
